import React from 'react'
import { Checkbox, Flex, Stack, Text, Alert, AlertIcon, Box } from '@chakra-ui/react'
import { ColDef } from 'ag-grid-community'
import { BaseGrid } from 'components/TailwindUIToolkit'
import { UtilityBill } from './types'
import { getStatusDisplay } from './helpers'

type BillSelectionStepProps = {
  bills: UtilityBill[]
  columns: ColDef<UtilityBill>[]
  likelyCandidateBills: UtilityBill[]
  onShowAllBillsChange: (showAllBills: boolean) => void
  rentalId: string
  showAllBills: boolean
  totalBillCount: number
}

export default function BillSelectionStep({
  bills,
  columns,
  likelyCandidateBills,
  onShowAllBillsChange,
  rentalId,
  showAllBills,
  totalBillCount
}: BillSelectionStepProps) {
  return (
    <Stack spacing={3}>
      <Flex justify='space-between' align='center' wrap='wrap' gap={3}>
        <Text color='gray.600' fontSize='sm'>
          {likelyCandidateBills.length > 0 && !showAllBills
            ? `Showing recent service-charge bills without existing chargebacks first (${bills.length} of ${totalBillCount}).`
            : `Showing ${bills.length} bill${bills.length === 1 ? '' : 's'}.`}
        </Text>
        <Checkbox
          isChecked={showAllBills}
          onChange={(event) => onShowAllBillsChange(event.target.checked)}
        >
          Show all bills
        </Checkbox>
      </Flex>

      {likelyCandidateBills.length === 0 && !showAllBills && (
        <Alert status='info'>
          <AlertIcon />
          No recent service-charge bills without chargebacks were found, so the full bill list is
          shown.
        </Alert>
      )}

      <Box h='28rem'>
        <BaseGrid<UtilityBill>
          columns={columns}
          rowData={bills}
          optionOverrides={{
            sideBar: false,
            pagination: true,
            paginationPageSize: 15
          }}
          defaultColDefOverrides={{
            floatingFilter: true,
            resizable: true,
            wrapText: false,
            autoHeight: false,
            minWidth: 140
          }}
          getRowStyle={({ data: bill }) => {
            if (!bill) {
              return undefined
            }

            return getStatusDisplay(bill, rentalId).isSelectable ? undefined : { opacity: 0.55 }
          }}
        />
      </Box>
    </Stack>
  )
}
